import React from 'react';
import PropTypes from 'prop-types';
import ImageGallery from 'react-image-gallery';
import cn from 'classnames';

import { generatePreview } from '../../utils';

import '../../../node_modules/react-image-gallery/styles/css/image-gallery.css';
import './BikeCardGallery.css';

const BikeCardGallery = ({
  className,
  photos
}) => {
  const bikePhotos = photos.map(({ image }) => ({
    original: generatePreview(image, 0, 227),
    thumbnail: generatePreview(image, 40, 30),
    fullscreen: image
  }));

  return (
    <div className={cn('bike-card-gallery', className)}>
      <ImageGallery
        disableKeyDown
        items={bikePhotos}
        showNav={false}
        showPlayButton={false}
        useBrowserFullscreen={false}
      />
    </div>
  );
};

BikeCardGallery.propTypes = {
  className: PropTypes.string,
  photos: PropTypes.array.isRequired
};

BikeCardGallery.defaultProps = {
  className: null
};

export default BikeCardGallery;



// WEBPACK FOOTER //
// ./src/widgets/BikeCard/BikeCardGallery.js